import React from 'react'
import Skeleton from 'react-loading-skeleton'

const LoaddingCommentComponent = () => {
  return (
    <div className='loadding-comment-con'>
        <div> <Skeleton className='loadding-sk' /> </div>
        <div><Skeleton className='loadding-sk' /></div>
        <div><Skeleton className='loadding-sk' /></div>
        <div><Skeleton className='loadding-sk' /></div>
        <div><Skeleton className='loadding-sk' /></div>
    </div>
  )
}

export default LoaddingCommentComponent
